import { render, staticRenderFns } from "./StreamCharacter.vue?vue&type=template&id=36e0b63a&scoped=true&"
import script from "./StreamCharacter.vue?vue&type=script&lang=js&"
export * from "./StreamCharacter.vue?vue&type=script&lang=js&"
import style0 from "./StreamCharacter.vue?vue&type=style&index=0&id=36e0b63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0b63a",
  null
  
)

export default component.exports